export enum SubmissionActionType {
    APPROVE = 'APPROVE',
    VIEW = 'VIEW'
}
